import { render, staticRenderFns } from "./QuestionnaireTemplateForm.vue?vue&type=template&id=5696f8d3&"
import script from "./QuestionnaireTemplateForm.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports